import { render } from "./NicePopup.vue?vue&type=template&id=262b3bec"
import script from "./NicePopup.vue?vue&type=script&lang=js"
export * from "./NicePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__